import CustomersService from "./customers.service";
import ClientService from "./client.service";
import EmployeeService from "./employee.service";
import GemsService from "./gems.service";
import { ApiService } from "./api.service";
// import VendorsService from "./vendors.service";
import TypesService from "./types.service";
import CategoriesService from "./categories.service";
import QuickNotes from "./quick.note.service";
import WeatherForecastService from "./weather.forecast.service";
import WebsiteService from "./website.service";
import ChartAccountService from "./chart.account.service";
import LedgerService from "./ledger.service";
import ClientStatusService from "./client.status.service";
// import CompanyIfnoService from "./company.info.service";
import WorkOrdersService from "./work.orders.service";
import EstimatesService from "./estimates.service";
import SaleReceiptsService from "./sale.receipts.service";
// import ItemsService from "./items.service";
import OtherContactsService from "./other.contacts.service";
import PrivateContactsService from "./private.contacts.service";
import NotepadsService from "./notepads.service";
import FilesService from "./files.service";
import StorageService from "./storage.service";
import UsersService from "./users.service";
import JobsService from "./jobs.service";
import VendorsService from "./vendors.service";
import ClientLoginService from "./client.login.service";
import JournalService from "./journal.entry.service";
import FolderService from "./folders.service";
import DrawerService from "./drawers.service";
import JournalViewService from "./journal.service";
import MessagesService from "./messages.service";
import SettingsService from "./settings.service";

import TerminologyService from "./terminology.service";
import TaskService from "./task.service";
import TasklistService from "./tasklist.service";

import CompanySettingService from "./company.settings.service.js";
import NotificationService from "./notification.service";
import ThemeSettingsService from "./theme.settings.service.js";
import ExportDataService from "./export.data.service.js";
import DirectionService from "./direction.service.js";
import RateService from "./rate.service.js";
import ArServiceService from "./ar.service.service.js";
import FieldService from "./fields.service.js";
import NotesService from "./notes.service.js";
import ClassificatinSevice from "./classifications.service.js";
import PayrollItemService from "./payroll.item.service.js";
import CalendarService from "./calendars.service.js";
import CalendarEventService from "./calendar.event.service.js";
import CalendarType from "./calendars.type.service.js";
import CalendarSettings from "./calendar.settings.service.js";
import EmailTemplate from "./email.template.service.js";
import EmailService from "./email.service.js";
import SearchEventService from "./search.event.service.js";
import InvoiceService from "./invoice.service.js";
import ReminderSerivce from "./reminder.service.js";
import LayoutService from "./layout.service.js";
import TaxSerivce from "./ar.tax.service";
import MessageSerivce from "./message.service";
import TermService from "./term.service.js";
import ArDeliveryMethodsService from "./ar.delivery.methods.service.js";
import ClassificatinService from "./classifications.service.js";
import TextEditorService from "./text.editor.service.js";
import DiscountService from "./discount.service.js";
import GoodService from "./ar.good.service.js";
import ArOtherChargeService from "./ar.other.charge.service.js";
import InventoryItemService from "./inventory.item.service.js";
import RecurringBillingService from "./setup.recurring.billing.service.js";
import StatusService from "./status.service.js";
import FixedAssets from "./fixed.assets.service.js";
import InvoiceSettingsService from "./invoice.settings.service.js";

import FileManagementService from "./file.management.service";
import ViewingFileComments from "./viewing.file.comments";
import FileCommentsService from "./file.comments.service";
import CommentsService from "./comments.service";
import CustomFieldsService from "./custom.fields.service";
import PermissionService from "./permission.service.js";
import TransactionService from "./transaction.service.js";
import ReceivalesProcessingService from "./receivables.processing.service.js";
import CreditMemoService from "./credit.memo.service.js";
import FundReceivedService from "./fund.received.service.js";
import DepositService from "./deposit.service";
import FileUploadDocumentService from "./file.upload.document.service.js";
import PrintQueService from "./print.que.service.js";
import CreditInformationReportService from "./credit.information.report.service.js";
import PeopleService from "./people.service";
import AllCalendarService from "./all.calendar.service";
import PropectService from "./prospect.service";
import ReceivablesItemsService from "./receivables.items.service";
import WarehouseLocationService from "./warehouse.location.service";
import WarehouseService from "./warehouse.service";
import InventoryReceivingService from "./inventory.receiving.service";
import InventoryReceivingItemService from "./inventory.receiving.item.service";
import PurchaseOrderService from "./purchase.order.service";
import ReturnItemService from "./return.item.service.js";
import FieldsetService from "./filedset.service.js";
import NotepadVersionService from "./notepad.version.service";
import ServiceReceivingService from "./service.receiving.service";
import AdjustInventoryService from "./adjust.inventory.service";
import GoodsReceivingService from "./goods.receiving.service";
import PaymentMethodsService from "./payment.method.service";
import ApplyCreditInvoiceService from "./apply.credit.invoice.service";
import BankingService from "./banking.service";
import CheckService from "./check.service";
import CheckLayoutService from "./check.layout.service";
import OtherFundReceivedService from "./other.fund.received";
import PaymentsService from "./payments.service";
import PayablesProcessingService from "./payables.processing.service";
import PayableBillService from "./payable.bill.service";
import PayableCreditService from "./payable.credit.service";
import TBEService from "./to.be.entered.service";
import TBAService from "./to.be.approved.service";
import TBPService from "./to.be.paid.service";
import ReviewTBAService from "./review.to.be.approved.service.js";
import PreviewTBAService from "./preview.to.be.paid.service";
import ReviewCheckService from "./review.check.service";
import PayablesAgingPeriodService from "./payables.aging.period";
import PayablesAgingSettingsService from "./payables.aging.settings.service";
import GenerateReportsService from "./generate.report.service";
import PrintCheckService from "./print.check.service";
import PrintAuthService from "./print.auth.service";
import CheckUserService from "./CheckUser.service";

import ImportantDatesService from "./important.dates.service";
import EmailSignatureService from "./email.signature.service.js";
import SentEmailService from "./sent.email.service.js";
import MessageTemplate from "./message.template.service.js";
import CopyPayablesService from "./copy.payables.service.js";
import SchedularService from "./schedular.service.js";
import InvoiceBuilderService from "./invoice.builder.service.js";
import SecureItemService from "./secure.item.service.js";
import WriteInvoiceService from "./writeoff.invoice.service.js";
import DefaultTerminologyService from "./default.terminology.service.js";
import BalanceSheetService from "./balance.sheet.service.js";
import AutomatedTasksService from "./automated.task.service.js";
import AutoMatedCreateService from "./automated.create.service.js";
import { label } from "@primeuix/themes/aura/metergroup";

const SERVICES = [];
//custome service
SERVICES[-1] = DrawerService;
SERVICES[-2] = FolderService;
SERVICES[-3] = MessagesService;
SERVICES[-4] = JournalViewService;
SERVICES[-5] = DirectionService;
SERVICES[-6] = RateService;
SERVICES[-7] = ArServiceService;
SERVICES[-8] = FieldService;
SERVICES[-9] = NotesService;
SERVICES[-10] = SettingsService;
SERVICES[-11] = TerminologyService;
SERVICES[-12] = CompanySettingService;
SERVICES[-13] = TasklistService;
SERVICES[-14] = ThemeSettingsService;
SERVICES[-15] = ExportDataService;
SERVICES[-16] = ClassificatinSevice;
SERVICES[-17] = PayrollItemService;
SERVICES[-18] = CalendarService;
SERVICES[-19] = CalendarType;
SERVICES[-20] = CalendarSettings;
SERVICES[-21] = EmailTemplate;
SERVICES[-22] = SearchEventService;
SERVICES[-23] = FieldsetService;
SERVICES[-24] = ReminderSerivce;
SERVICES[-25] = TaxSerivce;
SERVICES[-26] = MessageSerivce;
SERVICES[-27] = TermService;
SERVICES[-28] = LayoutService;
SERVICES[-29] = CustomFieldsService;
SERVICES[-30] = ArDeliveryMethodsService;
SERVICES[-31] = TextEditorService;
SERVICES[-32] = DiscountService;
SERVICES[-33] = GoodService;
SERVICES[-34] = ArOtherChargeService;
SERVICES[-36] = RecurringBillingService;
SERVICES[-37] = TransactionService;
SERVICES[-38] = PermissionService;
SERVICES[-39] = InvoiceSettingsService;
SERVICES[-40] = FileManagementService;
SERVICES[48] = DepositService;
SERVICES[-42] = CreditInformationReportService;
SERVICES[-43] = PeopleService;
SERVICES[-44] = AllCalendarService;
SERVICES[-45] = ViewingFileComments;
SERVICES[-46] = FileCommentsService;
SERVICES[-47] = WarehouseLocationService;
SERVICES[-48] = InventoryReceivingService;
SERVICES[-49] = WarehouseService;
SERVICES[-50] = InventoryReceivingItemService;
SERVICES[-51] = NotepadVersionService;
SERVICES[-52] = ServiceReceivingService;
SERVICES[-53] = AdjustInventoryService;
SERVICES[-54] = GoodsReceivingService;
SERVICES[-55] = PaymentMethodsService;
SERVICES[-56] = ApplyCreditInvoiceService;
SERVICES[-57] = CheckService;
SERVICES[-58] = CheckLayoutService;
SERVICES[-59] = OtherFundReceivedService;
SERVICES[-60] = PaymentsService;
SERVICES[-63] = TBEService;
SERVICES[-64] = TBAService;
SERVICES[-65] = TBPService;
SERVICES[-66] = ReviewTBAService;
SERVICES[-67] = PreviewTBAService;
SERVICES[-68] = ReviewCheckService;
SERVICES[-69] = PayablesAgingSettingsService;
SERVICES[-70] = PrintCheckService;
SERVICES[-71] = PrintAuthService;
SERVICES[-72] = LedgerService;
SERVICES[-73] = NotificationService;
SERVICES[-74] = CheckUserService;

SERVICES[1] = GemsService;
SERVICES[2] = TypesService;
SERVICES[3] = CategoriesService;
SERVICES[4] = StatusService;
SERVICES[14] = ImportantDatesService;

SERVICES[17] = EmployeeService;
SERVICES[18] = VendorsService;
// SERVICES[76] = CompanyIfnoService;
SERVICES[171] = WorkOrdersService;
SERVICES[10] = InventoryItemService;
SERVICES[38] = FixedAssets;
SERVICES[40] = EstimatesService;
SERVICES[45] = JobsService;
SERVICES[117] = SaleReceiptsService;
SERVICES[144] = TaskService;
// SERVICES[136] = ItemsService;
SERVICES[148] = OtherContactsService;
SERVICES[149] = PrivateContactsService;
SERVICES[156] = NotepadsService;
SERVICES[166] = StorageService;
SERVICES[169] = FilesService;
SERVICES[89] = UsersService;

SERVICES[23] = ClientService;
SERVICES[209] = ClientStatusService;
SERVICES[210] = ClientLoginService;
SERVICES[34] = CustomersService;

SERVICES[24] = PayablesAgingPeriodService;
SERVICES[25] = QuickNotes;
SERVICES[75] = WeatherForecastService;
SERVICES[116] = WebsiteService;
SERVICES[-41] = ClassificatinService;
SERVICES[56] = CreditMemoService;
SERVICES[58] = ChartAccountService;
SERVICES[59] = BalanceSheetService;
SERVICES[190] = CalendarEventService;
SERVICES[174] = JournalService;

SERVICES[137] = ReceivalesProcessingService;

SERVICES[180] = FundReceivedService;
SERVICES[128] = FileUploadDocumentService;
SERVICES[194] = PrintQueService;
SERVICES[145] = PropectService;
SERVICES[136] = ReceivablesItemsService;
SERVICES[203] = PurchaseOrderService;
SERVICES[177] = BankingService;
SERVICES[140] = PayablesProcessingService;
SERVICES[176] = PayableBillService;
SERVICES[178] = PayableCreditService;
SERVICES[186] = GenerateReportsService;

// its an annoucement domain but currently we use return items for testing after that we remove it
SERVICES[200] = ReturnItemService;
SERVICES[208] = EmailService;
SERVICES[209] = EmailSignatureService;
SERVICES[210] = SentEmailService;
SERVICES[211] = MessageTemplate;

SERVICES[212] = CommentsService;

// Payables
SERVICES[157] = InvoiceService;
SERVICES[213] = CopyPayablesService;
SERVICES[214] = SecureItemService;
SERVICES[61] = WriteInvoiceService;

// Latest [we start gem number from 300]
SERVICES[300] = SchedularService;
SERVICES[301] = InvoiceBuilderService;
SERVICES[302] = DefaultTerminologyService;
SERVICES[304] = AutomatedTasksService;
SERVICES[305] = AutoMatedCreateService;

export function getDomainNames(onlySchedule = false) {
  let domains = [];
  let indx = 0;
  Object.keys(SERVICES).forEach((key) => {
    const domain = Number(key);
    const service = SERVICES[domain];
    if (!service) return;
    let tmpSrv = new service();
    let condition = onlySchedule
      ? (tmpSrv?.singular || tmpSrv?.name) && tmpSrv.enableSchedular
      : tmpSrv?.name;
    if (tmpSrv.enableSchedular)
    if (condition) {
      domains[indx++] = {
        id: domain,
        label: tmpSrv.name || tmpSrv?.singular,
        labelKey: tmpSrv?.labelKey || "display_name",
      };
    }
  });
  return domains;
}

export function getDomainLabelKey(domainId) {
  if (domainId == null || domainId === "") return "display_name";
  const svc = getMyGemService(Number(domainId));
  return svc?.labelKey || "display_name";
}

// service with gem id
export function getMyGemService(gemId) {
  if (SERVICES[gemId]) return new SERVICES[gemId]();

  return new ApiService();
}
